export default __webpack_public_path__ + "images/RG.27b6cba.png";